import { render } from "./index.vue?vue&type=template&id=55ecbdb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=55ecbdb0&scoped=true&lang=css"

import exportComponent from "/Users/johnkabiu/Development/Projects/Liden/Front-End/VueJs/mobi_games/mobi_games/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ecbdb0"]])

export default __exports__